import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { CustomModalContainerComponent } from './custom-modal-container.component';
// import { CustomModalBackdropComponent } from './custom-modal-backdrop.component';

@NgModule({
  // declarations: [CustomModalContainerComponent, CustomModalBackdropComponent],
  imports: [CommonModule],
  exports: [],
})
export class CustomModalModule {
  /**
   * Call this in the root module only (same pattern as HttpClientModule.forRoot())
   */
  static forRoot(): ModuleWithProviders<CustomModalModule> {
    return {
      ngModule: CustomModalModule,
      providers: [],
    };
  }
}
